import React from 'react';
import LedgerDatasetTableShell, { LedgerDatasetTableShellProps } from '../shared/LedgerDatasetTableShell';

type APLedgerTableProps = Omit<LedgerDatasetTableShellProps, 'view' | 'accountingSource'>;

const APLedgerTable: React.FC<APLedgerTableProps> = (props) => (
    <LedgerDatasetTableShell {...props} view="ar" accountingSource="ap_ledger" />
);

export default APLedgerTable;
